import React from 'react';

import {useCurrentPlan} from '@views/Account/Plan/_hooks/useCurrentPlan';
import {useCurrentBoxId} from '@views/Account/Plan/_hooks/useCurrentBoxId';

import {ActionCancelOrder} from './ActionCancelOrder';
import {ActionSkipOrder} from './ActionSkipOrder';

interface ActionSkipOrCancelOrderProps {
  onSuccess: () => Promise<void>;
}

export const ActionSkipOrCancelOrder: React.FC<ActionSkipOrCancelOrderProps> = ({onSuccess}) => {
  const {isOnDemand} = useCurrentPlan();
  const {boxId} = useCurrentBoxId();

  if (isOnDemand) {
    return <ActionCancelOrder boxId={boxId} onSuccess={onSuccess} />;
  }

  return <ActionSkipOrder onSuccess={onSuccess} />;
};
